import {ColumnFilterItem} from 'antd/lib/table/interface';
import {isString} from 'lodash';

export function isStringArray(
    array: Array<ColumnFilterItem & {selected: boolean}>
): array is Array<ColumnFilterItem & {selected: boolean; text: string}> {
    return array.every((value) => isString(value.text));
}
